import { render, staticRenderFns } from "./ViewHistory.vue?vue&type=template&id=0526f8da&scoped=true"
import script from "./ViewHistory.vue?vue&type=script&lang=js"
export * from "./ViewHistory.vue?vue&type=script&lang=js"
import style0 from "./ViewHistory.vue?vue&type=style&index=0&id=0526f8da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0526f8da",
  null
  
)

export default component.exports